import React from "react";
import "./AboutUs.css";
import aboutImg from "../assets/aboutus.png";
const AboutUs = () => {
  return (
    <div className="about-container">
      <div className="about-image">
        <img src={aboutImg} alt="Paint rollers" />
      </div>
      <div className="about-content">
        <h2>About Us</h2>
        <p>
          RUNGDO is your one-stop destination for all your painting needs.
          Whether you're a professional painter or a DIY enthusiast, we've got
          you covered with a wide range of premium paints and supplies to bring
          your vision to life.
        </p>
        <p>
          We offer a vast selection of high-quality paints from renowned brands,
          ensuring durability, vibrant color, and a flawless finish every time.
          From interior and exterior paints to specialty coatings, RUNGDO is
          committed to providing the best products and expert support to make
          your painting project a success.
        </p>
        <div className="about-buttons">
          <button className="btn-primary">Order Your Paint Now</button>
          <button className="btn-secondary">Learn More</button>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
